import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import FilterBox from '../common/FilterBox';
const KeyboardUtil = require("../../util/keyboard");

const propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    currentPage: PropTypes.number.isRequired,
    numPages: PropTypes.number.isRequired,
    filterPages: PropTypes.number.isRequired,
    totalRecords: PropTypes.number.isRequired,
    searchTerm: PropTypes.string,
    requestPage: PropTypes.func.isRequired,
    hideSearch: PropTypes.bool,
    filter: PropTypes.string,
    filterApplied: PropTypes.string,
    onFilterChange: PropTypes.func.isRequired,
    doApplyFilter: PropTypes.func.isRequired,
};

const defaultProps = {
    className: '',
    searchTerm: '',
    hideSearch: false,
};


function PaginationControls(props) {
    function onFilterChange(e) {
        props.onFilterChange(e.target.value);
    }
    
    function onFilterKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            (props.numPages > 1) ? props.requestPage(1) : props.doApplyFilter()
        }
    }
    

    const overallNumPages = props.numPages;
    const currentNumPages = props.searchTerm ? props.filterPages : props.numPages;
    const hasMultipleRecords = (props.totalRecords > 1);
    const hasMultiplePages = (currentNumPages > 1);
    let pageButtons;

    if (!hasMultiplePages || !hasMultipleRecords) {
        pageButtons = null;
    }
    else if (hasMultiplePages) { // show 10 page numbers at a time
        pageButtons = [];
        const firstPage = Math.max(1, props.currentPage - 4);
        const lastPage = Math.min(firstPage + 9, currentNumPages);
        const pageSet = Math.ceil(props.currentPage / 10);
        const prevSetPage = (pageSet - 1) * 10 - 5;
        const nextSetPage = (pageSet + 1) * 10 - 5;
        
        if (firstPage > 1) {
            pageButtons.push(
                <Button key={1} onClick={props.requestPage.bind(null, 1)}>
                    {'|<'}
                </Button>
            );
        }
        
        if (prevSetPage > 1) {
            pageButtons.push(
                <Button key={prevSetPage} onClick={props.requestPage.bind(null, prevSetPage)}>
                    {'<<'}
                </Button>
            );
        }
        
        for (let page = firstPage; page <= lastPage; ++page) {
            if (page === props.currentPage) {
                pageButtons.push(
                    <Button key={page} className="current-page" disabled>
                        {page}
                    </Button>
                );
            }
            else {
                const pageFunc = props.requestPage.bind(null, page);
                // () => { props.requestPage(page); } <---- doesn't work (uses the value of page after the end of the loop???
                pageButtons.push(
                    <Button key={page} onClick={pageFunc}>
                        {page}
                    </Button>
                );
            }
        }
        
        if (nextSetPage < currentNumPages) {
            pageButtons.push(
                <Button key={nextSetPage} onClick={props.requestPage.bind(null, nextSetPage)}>
                    {'>>'}
                </Button>
            );
        }
        
        if (lastPage < currentNumPages) {
            pageButtons.push(
                <Button key={currentNumPages} onClick={props.requestPage.bind(null, currentNumPages)}>
                    {'>|'}
                </Button>
            );
        }
    }

    let searchButton = null;
    let searchEnabled;
    if (hasMultipleRecords) {
        if (overallNumPages > 1) {
            const filterChanged = (props.searchTerm != props.filter);
            searchButton = (
                <button
                    className="bare-text-button glyph"
                    disabled={!filterChanged}
                    onClick={() => { if (filterChanged) props.requestPage(1); }}
                >
                    <i className={"fa fa-search" + (filterChanged ? "":" disabled")} aria-hidden />
                    <span className="sr-only">Filter</span>
                </button>
            );
            searchEnabled = filterChanged;
        }
        else {
            const different = (props.filter !== props.filterApplied);
            searchButton = (
                <button
                    className="bare-text-button glyph"
                    disabled={!different}
                    onClick={()=>{ if (different) props.doApplyFilter() }}
                >
                    <i className={"fa fa-search" + (different ? "":" disabled")} aria-hidden />
                    <span className="sr-only">Filter</span>
                </button>
            );
            searchEnabled = different;
        }
    }

    return (
        <div id={props.id} className={`paginationRow ${props.className}`}>
            {(hasMultipleRecords && !props.hideSearch) &&
                <div className="paginationRow__filter">
                    <FilterBox
                        inputId={`${props.id}-filter`}
                        className="pagination-filter margin-bottom-md margin-right-md"
                        icon="fa fa-font"
                        label="Filter"
                        onKeyDown={searchEnabled ? onFilterKeyDown : null}
                        onChange={onFilterChange}
                        value={props.filter}
                    />
                    {searchButton}
                </div>
            }
            <div className="paginationRow__pageButtons">
                {pageButtons}
            </div>
        </div>
    );
}

PaginationControls.propTypes = propTypes;
PaginationControls.defaultProps = defaultProps;

export default PaginationControls;